import React, { Component } from 'react'
import './style.css'
import { Query } from "react-apollo";
import gql from "graphql-tag";
import RequestsList from "../../containers/requests/List"
import RequestsDetails from "../../containers/requests/Details"

const QUERY = gql`
{
  requests(order: DESC, orderBy: "created_at") {
    id
    _id
    state
    started
    start_date
    completed
    started
    ended
    request_students {
      id
      student {
        id
        _id
        first_name
        last_name
      }
    }
    tutor {
      id
      _id
      user {
        id
        _id
        first_name
        last_name
      }
    }
  }
}
`

class Requests extends Component {
  render() {

    return (
      <React.Fragment>

        <div className="messages-container">

          <div className="messages-list">
            <Query
                query={QUERY}
                variables={{
                  cursor: 0
                }}
                >
                {({ loading, error, data, fetchMore }) => {
                if (loading) return <p>Loading...</p>;
                if (error) {
                  console.error(error)
                  return <p>Error :(</p>
                };

                return <RequestsList
                  requests={data.requests}
                  active={this.props.match.params.uuid}
                  /> 

                }}
            </Query>
          </div>

          <div className="details-section">
            <RequestsDetails uuid={this.props.match.params.uuid} />
          </div>


        </div>

        
    </React.Fragment>
      
    );
  }
}

export default Requests;



// WEBPACK FOOTER //
// ./src/views/Requests/index.js